import { aclFeatures } from '@/lib/acl/aclFeatures';

export const DRAFT = 'draft';
export const SCHEDULED = 'scheduled';
export const WAITING_FOR_APPROVAL = 'waiting_for_approval';
export const APPROVED = 'approved';
export const REJECTED = 'rejected';
export const REMINDER = 'reminder';

export const POST_STATUS = {
    [DRAFT]: {
        color: '#ff8800',
        text: 'scheduler:status.draft',
        icon: 'document'
    },
    [SCHEDULED]: {
        color: '#4fd046',
        text: 'scheduler:status.scheduled',
        icon: 'scheduled'
    },
    [WAITING_FOR_APPROVAL]: {
        color: '#7900ff',
        text: 'scheduler:status.waiting_for_approval',
        icon: 'clock',
        permissions: aclFeatures.publishing.external_collaboration.read
    },
    [APPROVED]: {
        color: '#0089ff',
        text: 'scheduler:status.approved',
        icon: 'check',
        permissions: aclFeatures.publishing.external_collaboration.read
    },
    [REJECTED]: {
        color: '#ee3034',
        text: 'scheduler:status.rejected',
        icon: 'rejected',
        permissions: aclFeatures.publishing.external_collaboration.read
    },
    [REMINDER]: {
        color: '#AEB9C6',
        text: 'scheduler:status.reminder',
        icon: 'soon',
        permissions: aclFeatures.publishing.external_collaboration.read
    }
};
